module.exports = __webpack_public_path__ + "static/network2-f4407280e2e988dbb626e4252533a439.jpg";